<div class="atn-widget-builder-general-tab">
  <div class="atn-widget-builder-general-tab__info">
    <atn-ds-text
      label="Name"
      placeholder="Enter a name"
      [value]="widgetNameSg()"
      (change)="updateWidget('name', $event ?? '')"
    ></atn-ds-text>
    <atn-ds-text
      label="Alias"
      placeholder="Enter an alias"
      [value]="widgetAliasSg()"
      (change)="updateWidget('alias', $event ?? '')"
    ></atn-ds-text>
    <atn-ds-text
      label="Description"
      placeholder="Enter a description"
      [value]="widgetDescriptionSg()"
      (change)="updateWidget('description', $event)"
    ></atn-ds-text>
  </div>
  <div class="atn-widget-builder-general-tab__variables">
    <atn-variables-table />
  </div>
</div>

<atn-widget-builder-variable />
